module.exports = __webpack_public_path__ + "img/肌如初雪套装_10.b099def6.jpg";